module.exports = __webpack_public_path__ + "static/media/012-Erkundigen_oV_ID_17.0ef217ce.mp3";